export default __webpack_public_path__ + "locales/si/Files.json?hash=198837a3a6ff42b6d274993a19225ee9";